module.exports = __webpack_public_path__ + "img/vip.19dbc410.png";